import { createAction } from '@reduxjs/toolkit';
import { SessionReducerShape } from './session.types';

export const addSessionDataInfo = createAction<
  Partial<SessionReducerShape>,
  'session/ADD_SESSION_INFO'
>('session/ADD_SESSION_INFO');

/**
 * Invoked when a user requests a logout.
 */
export const logoutRequest = createAction('session/LOGOUT_REQUEST');

/**
 * Used internally to programmatically clean the store.
 * Note: do not invoke it directly use 'logoutRequest' instead.
 */
export const endUserSession = createAction('session/END_USER_SESSION');
